export const nl = {
  validate: {
    title: 'Cadeau Portaal',
    subtitle: 'Vul je kaartnummer en pincode in om je cadeau te kiezen.',
    cardNumber: 'Kaartnummer',
    pin: 'Pincode',
    cardPlaceholder: 'Vul je kaartnummer in',
    pinPlaceholder: 'Vul je pincode in',
    continue: 'Doorgaan',
    errors: {
      invalid: 'Ongeldig kaartnummer of pincode',
      inactive: 'Deze voucher is niet actief',
      redeemed: 'Deze voucher is al ingewisseld',
      expired: 'Deze voucher is verlopen',
      invalidCredentials: 'Ongeldige kaart of pincode',
      cardUsed: 'Deze kaart kan niet meer worden gebruikt',
      rateLimited: 'Te veel pogingen. Probeer het later opnieuw.',
      addressRequired: 'Vul een naam en postcode in om dit cadeau te claimen',
      emailRequired: 'Vul een geldig e-mailadres in om dit cadeau te claimen',
      unknown: 'Er is iets misgegaan',
    },
  },
  select: {
    title: 'Welkom',
    subtitle:
      'Kies één van de cadeaus hieronder. Meer informatie over je cadeau ontvang je per e-mail.',
    noGifts: 'Er zijn geen cadeaus beschikbaar voor deze voucher.',
    emailLabel: 'E-mailadres',
    emailPlaceholder: 'email@voorbeeld.nl',
    emailInvalid: 'Vul een geldig e-mailadres in',
    emailBarLabel: 'De bevestigingsmail wordt verstuurd naar:',
    emailEmpty: 'Nog geen e-mail ingesteld',
    changeEmail: 'wijzig e-mail',
    chooseButton: 'Kies',
    chosenButton: 'Gekozen',
    selectButton: 'Cadeaubon inwisselen',
    changeEmailTitle: 'E-mailadres wijzigen',
    changeEmailSubtitle:
      'Werk het e-mailadres bij waar je cadeau naartoe wordt gestuurd.',
    cancel: 'Annuleren',
    save: 'Opslaan',
    addressTitle: 'Bezorgadres',
    addressSubtitle: 'Het adres dat bij dit cadeau bekend is',
    addressEmptyNotice:
      'We hebben nog geen bezorgadres van je. Vul het hieronder in.',
    addressSave: 'Opslaan en claimen',
    addressNameLabel: 'Volledige naam',
    addressStreetNameLabel: 'Straat',
    addressHouseNumberLabel: 'Huisnummer',
    addressPostcodeLabel: 'Postcode',
    addressCityLabel: 'Plaats',
    addressCountryLabel: 'Land',
    addressFieldRequired: 'Dit veld is verplicht',
  },
  success: {
    title: 'Cadeau verstuurd naar je e-mailadres',
    body: 'Controleer je inbox op {email} om je cadeau te vinden',
    errorTitle: 'Er is iets misgegaan',
    tryAgain: 'Opnieuw proberen',
    footerPrivacy: 'Privacybeleid',
    footerTerms: 'Servicevoorwaarden',
  },
  email: {
    subject: 'Hier is je cadeaucode!',
    codeLabel: 'Jouw unieke code',
    intro: 'Hier is je cadeaucode:',
    nameLabel: 'Naam',
    poweredBy: 'powered by',
  },
  langSwitch: 'EN',
} as const
